import * as echarts from 'echarts';
let animationDuration = 2000;

function getColor(color1, color2) {
	return new echarts.graphic.LinearGradient(
		0, 0, 0, 1, // 从上到下渐变
		[{
			offset: 0,
			color: color1
		}, {
			offset: 1,
			color: color2
		}]
	)
}

function setData(data, name = undefined, color = getColor('#00ffea', '#3ac1ff'), barWidth = '5%') {
	return {
		name,
		data,
		type: 'bar',
		barWidth, // 设置柱子宽度（也可以是具体像素：'30'）
		itemStyle: {
			color
		},
		label: {
			color: '#FFF'
		},
	}
}

function setZData(data, color, name = undefined, areaStyle) {
	return {
		name,
		type: 'line',
		data,
		smooth: true,
		symbol: 'circle',
		symbolSize: 3,
		showSymbol: true,
		lineStyle: {
			width: 2,
			color
		},
		itemStyle: {
			color
		},
		areaStyle: areaStyle ? {
			color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					offset: 0,
					color: color
				}, // 顶部：线条颜色
				{
					offset: 1,
					color: 'rgba(0,0,0,0)'
				} // 底部：透明
			])
		} : undefined
	}
}


function getGasList(listNum = 8, fixed = 2) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * 150 + 50).toFixed(fixed)))
	}
	return val
}

function getBFBList(listNum, fixed) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * 100).toFixed(fixed)))
	}
	return val
}


export const chart1 = {
	animationDuration,
	series: [{
		type: 'gauge',
		// startAngle: 90,
		// endAngle: -270,
		pointer: {
			show: false
		},
		progress: {
			show: true,
			overlap: false,
			roundCap: false,
			clip: false,
			itemStyle: {
				borderWidth: 1,
				// borderColor: '#464646'
			}
		},
		axisLine: {
			lineStyle: {
				width: 30,
				opacity: 0
			}
		},
		splitLine: {
			show: false,
			distance: 0,
			length: 10
		},
		axisTick: {
			show: false
		},
		axisLabel: {
			show: false,
			distance: 50
		},
		title: {
			fontSize: 14,
			show: false
		},
		detail: {
			show: false
			// width: 50,
			// height: 14,
			// fontSize: 14,
			// color: 'inherit',
			// borderColor: 'inherit',
			// borderRadius: 20,
			// borderWidth: 1,
			// formatter: '{value}%'
		},
		data: [{
				value: 100,
				itemStyle: {
					color: getColor('#5ddef7', '#0a6ed6'),
				},
			},
			{
				value: 100,
				itemStyle: {
					color: '#0f1e33',
				},
			},

			{
				value: 100,
				itemStyle: {
					color: '#17374f',
				},
			},
		]
	}]
};


export const chart2 = {
	animationDuration,
	series: [{
		type: 'gauge',
		// startAngle: 90,
		// endAngle: -270,
		pointer: {
			show: false
		},
		progress: {
			show: true,
			overlap: false,
			roundCap: false,
			clip: false,
			itemStyle: {
				borderWidth: 1,
				// borderColor: '#464646'
			}
		},
		axisLine: {
			lineStyle: {
				width: 30,
				opacity: 0
			}
		},
		splitLine: {
			show: false,
			distance: 0,
			length: 10
		},
		axisTick: {
			show: false
		},
		axisLabel: {
			show: false,
			distance: 50
		},
		title: {
			fontSize: 14,
			show: false
		},
		detail: {
			show: false
			// width: 50,
			// height: 14,
			// fontSize: 14,
			// color: 'inherit',
			// borderColor: 'inherit',
			// borderRadius: 20,
			// borderWidth: 1,
			// formatter: '{value}%'
		},
		data: [{
				value: 100,
				itemStyle: {
					color: getColor('#5ddef7', '#0a6ed6'),
				},
			},
			{
				value: 100,
				itemStyle: {
					color: '#0f1e33',
				},
			},

			{
				value: 100,
				itemStyle: {
					color: '#17374f',
				},
			},
		]
	}]
};


export const chart3 = {
	animationDuration,
	title: {
		show: false
	},
	tooltip: {
		show: true
	},
	legend: {
		show: false
	},
	series: [{
		name: '能源中心数量',
		type: 'pie',
		radius: '50%',
		radius: ['36%', '70%'],
		label:{
			show:true,
			formatter: '{b} \t ({c}%)',
			textShadowColor: 'transparent',
			color: '#3ed3eb'
		},
		data: [{
				value: 6.46,
				name: '循环泵3',
				itemStyle: {
					color: '#ff9393'
				},
			},
			{
				value: 1.08,
				name: '循环泵2',
				itemStyle: {
					color: '#f36565'
				},
			},
			{
				value: 13.45,
				name: '3号双工况冷水机组',
				itemStyle: {
					color: '#f1c13b'
				},
			},
			{
				value: 0.75,
				name: '循环泵1',
				itemStyle: {
					color: '#ff972f'
				},
			},
			{
				value: 15.39,
				name: '2号双工况冷水机组',
				itemStyle: {
					color: '#8b9fff'
				},
			},
			{
				value: 15.79,
				name: '1号双工况冷水机组',
				itemStyle: {
					color: '#5555f5'
				},
			},
			{
				value: 2.18,
				name: '循环泵8',
				itemStyle: {
					color: '#41a3f3'
				},
			},
			{
				value: 14.31,
				name: '内融冰池',
				itemStyle: {
					color: '#19579b'
				},
			},
			{
				value: 2.35,
				name: '循环泵7',
				itemStyle: {
					color: '#3dd3ea'
				},
			},
			{
				value: 6.41,
				name: '1号板换',
				itemStyle: {
					color: '#ff9393'
				},
			},
			{
				value:11.09,
				name: '2号板换',
				itemStyle: {
					color: '#f36565'
				},
			},
			{
				value: 5.81,
				name: '循环泵6',
				itemStyle: {
					color: '#f1c13b'
				},
			},
			{
				value: 2.69,
				name: '循环泵5',
				itemStyle: {
					color: '#ff972f'
				},
			},
			{
				value: 2.15,
				name: '循环泵4',
				itemStyle: {
					color: '#8b9fff'
				},
			}
		],
		emphasis: {
			itemStyle: {
				shadowBlur: 20,
				shadowOffsetX: 10,
				// shadowColor: 'rgba(0, 0, 0, 0.5)'
			}
		}
	}]
};


export const chart4 = {
	animationDuration,
	title: {
		show: false
	},
	tooltip: {
		show: true
	},
	legend: {
		show: false
	},
	series: [{
		name: '光伏数量',
		type: 'pie',
		radius: '50%',
		radius: ['36%', '70%'],
		label:{
			show:true,
			formatter: '{b} \t ({c}%)',
			textShadowColor: 'transparent',
			color: '#3ed3eb'
		},
		data: [{
				value: 0,
				name: '维修中',
				itemStyle: {
					color: '#3dd3eb'
				},
			},
			{
				value: 0,
				name: '关机中',
				itemStyle: {
					color: '#41a3f3'
				},
			},
			{
				value: 0,
				name: '维保中',
				itemStyle: {
					color: '#4f6bed'
				},
			},
			{
				value: 0,
				name: '故障中',
				itemStyle: {
					color: '#65ed9f'
				},
			},
			{
				value: 0,
				name: '停机中',
				itemStyle: {
					color: '#37b36d'
				},
			},
			{
				value: 100,
				name: '进行中',
				itemStyle: {
					color: '#1f7b71'
				},
			},
		],
		emphasis: {
			itemStyle: {
				shadowBlur: 20,
				shadowOffsetX: 10,
				// shadowColor: 'rgba(0, 0, 0, 0.5)'
			}
		}
	}]
};